import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import React, { useState, useEffect } from "react";
import MarkdownRenderer from "../../MarkdownRenderer";
import { stripFrontMatter } from "../../../utils/markdownHelpers";
import geoBackendIntegrationFile from "../../../assets/markDownFiles/verify/backend_integration.md";

// The ACT Geo API Backend Integration Guide (CreateSession and VerifySession),
// the server half of ACT Geosafe (Web). Like the Web SDK guide, it only has its
// front matter removed so `{...}` in the text is kept.
const GeoBackendIntegration = () => {
  const [content, setContent] = useState("");
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  useEffect(() => {
    if (
      typeof geoBackendIntegrationFile === "string" &&
      geoBackendIntegrationFile.startsWith("/static")
    ) {
      fetch(geoBackendIntegrationFile)
        .then((res) => res.text())
        .then((raw) => setContent(stripFrontMatter(raw)));
    } else {
      setContent(stripFrontMatter(geoBackendIntegrationFile));
    }
  }, []);

  return (
    <Box sx={{ padding: "0" }}>
      <Typography
        sx={{
          color: "#e54f9c",
          fontWeight: "900",
          fontSize: "0.8rem",
          marginBottom: "0.35rem",
          marginLeft: isDesktop ? "0" : "5%",
        }}
      >
        ACT Verify
      </Typography>
      {content ? <MarkdownRenderer content={content} /> : <p>Loading...</p>}
    </Box>
  );
};

export default GeoBackendIntegration;
